import { render, staticRenderFns } from "./LocalePicker.vue?vue&type=template&id=a0165c38"
import script from "./LocalePicker.vue?vue&type=script&lang=ts"
export * from "./LocalePicker.vue?vue&type=script&lang=ts"
import style0 from "./LocalePicker.vue?vue&type=style&index=0&id=a0165c38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports